import Api from '@api/taskOfOpeningShop'
import { action, observable } from 'mobx'

class Store {
  @observable step = 1

  @action
  changeStep = num => () => {
    this.step = num
  }

  @action
  finishGuide = async () => {
    const { success } = await Api.finishNewGuidelines()
    if (success) {
      window.location.reload()
    }
  }
}
export default Store
